import React from 'react';
import { aboutParagraph } from '../data/content';
export function About() {
  return <section id="about" aria-labelledby="about-heading" className="scroll-mt-16 border-b border-hairline bg-slate-50 py-20 sm:py-24" data-id="element-10" data-mp="2pr73h1mhdfzn">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-11" data-mp="2trr2kaqm6tof">
        <div className="max-w-3xl" data-id="element-12" data-mp="2ysf1dil34et7">
          <h2 id="about-heading" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-13" data-mp="2ytgh40d1pph9">
            About
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ink-muted" data-id="element-14" data-mp="38pb4t9w4maqw">
            {aboutParagraph}
          </p>
        </div>
      </div>
    </section>;
}